import { render } from "./AccountDetailsOrdersTab.vue?vue&type=template&id=d91aa5d6"
import script from "./AccountDetailsOrdersTab.vue?vue&type=script&lang=js"
export * from "./AccountDetailsOrdersTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__